import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { industryLabels } from "@components/entity/constants";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import type { ApplyCloseTemplateEntitySelectionRow } from "../applyCloseTemplateEntitySelection.types";
import { buildMultiSelectLabel } from "./closeTemplateMultiSelectLabel";

export const ApplyCloseEntityIndustriesCell = memo(
    ({
        row,
    }: CellContext<
        ViewTableFeatures,
        ApplyCloseTemplateEntitySelectionRow,
        unknown
    >) => {
        if (row.original.isClientRow) {
            return <ViewTableCell />;
        }

        const label = buildMultiSelectLabel(
            row.original.industries,
            industryLabels,
            "industry",
        );

        return (
            <ViewTableCell>
                <span className="text-secondary">{label}</span>
            </ViewTableCell>
        );
    },
);
